import { mapGetters, mapActions, mapMutations } from 'vuex'
import service from '@/helper/const'
import moment from 'moment'

import {
  FileUpload,
  UpdateBillet,
  PeriodExtract,
  CloseExtract,
  ConfirmDeleteInvoice,
  FileDownloadButton
} from '@/components'

export default {
  components: {
    FileUpload,
    UpdateBillet,
    PeriodExtract,
    CloseExtract,
    ConfirmDeleteInvoice,
    FileDownloadButton
  },
  data () {
    return {
      rules: {
        datadc: (value) => this.validateDate(value) || ''
      },
      managerConfirmDeleteInvoice: false,
      managerDownloadFile: false,
      isLoadingValueInvoice: false,
      selectedClient: '',
      endDate: null,
      endDateFormated: null,
      menuEndDate: false,
      menuPaymentDate: false,
      paymentDateFormated: null,
      paymentDate: null,
      isLoading: false,
      pagination: {},
      headers: [
        { text: 'Ações', align: 'center', sortable: false },
        { text: 'Nome', value: 'clientName', align: 'left' },
        { text: 'CPF/CNPJ', value: 'clientCnpj', align: 'left' },
        { text: 'Data de fechamento', value: 'closingDay', align: 'left' },
        { text: 'Identificador boleto', value: 'idBillet', align: 'center' },
        { text: 'Observações', value: 'observation', align: 'center' },
        { text: 'Valor extrato', value: 'valueInvoice', align: 'right' },
        { text: 'Valor pago', value: 'paidValue', align: 'right' },
        { text: 'Data do pagamento', value: 'paymentDate', align: 'center' },
        { text: 'Pago', value: 'settled', align: 'center' }
      ],
      listActions: [
        {
          name: 'Fechar extrato',
          value: 'close-extract',
          action: (item) => this.managerPaymentModals('close-extract', item),
          disabled: (condition) => this.validateDisabledButton('close-extract', condition)
        },
        {
          name: 'Identificador boleto',
          value: 'identifier',
          action: (item) => this.managerPaymentModals('identifier', item),
          disabled: (condition) => this.validateDisabledButton('identifier', condition)
        },
        {
          name: 'Remover extrato',
          value: 'remove-extract',
          action: (item) => this.managerPaymentModals('remove-extract', item),
          disabled: (condition) => this.validateDisabledButton('remove-extract', condition)
        }
      ],
      listFiltersInvoicePaid: [
        { name: 'Sim', value: true },
        { name: 'Não', value: false }
      ],
      selectedItemFiltersInvoicePaid: null,
      selectedInvoice: {},
      uploadedFile: [],
      isLoadingAllClients: false,
      isLoadingSendFile: false,
      isLoadingUpdateBillet: false,
      managerUpdateBillet: false,
      managerPeriodExtract: false,
      managerCloseExtract: false,
      isLoadingProductPlans: false,
      identificatorBillet: '',
      selectedProduct: null,
      showCreditInfo: false,
      filterByStatus: false,
      loadPayments: false,
      selectedClientPlanType: null,
      loadingCredit: false,
      showSection: false
    }
  },
  computed: {
    ...mapGetters([
      'getterClients',
      'getterAccount',
      'getterFileSended',
      'getterAllInvoices',
      'getterAllProductPlans',
      'getterSelectedInvoice',
      'getterCreditInfo',
      'getterPlanType'
    ]),
    filteredInvoices () {
      let refactoredList = []

      if (this.getterAllInvoices && this.getterAllInvoices.data && this.getterAllInvoices.data.length > 0) {
        refactoredList = this.getterAllInvoices.data.map((item) => ({
          ...item,
          checkedPaymentDate: (item.paymentDate === '0001-01-01T00:00:00') ? '-' : item.paymentDate,
          paid: item.settled ? 'Sim' : 'Não'
        }))
      }

      if (this.filterByStatus) {
        refactoredList = refactoredList.filter((item) => item.settled === false)
      }

      return refactoredList
    },
    barPercentage () {
      if (this.getterCreditInfo.clientType === 'pre') {
        return (this.getterCreditInfo.currentAmount / this.getterCreditInfo.retainedAmount) * 100
      }
      if (!this.getterCreditInfo.currentAmount) {
        return 0
      } if (this.getterCreditInfo.currentAmount >= this.getterCreditInfo.clientLimit) {
        return 100
      }
      return (this.getterCreditInfo.currentAmount / this.getterCreditInfo.clientLimit) * 100
    },
    availableCredit () {
      return this.getterCreditInfo.clientLimit - this.getterCreditInfo.currentAmount
    },
    isDisabled () {
      return (!this.selectedClient || this.selectedClient === '') && this.endDate === null && this.selectedProduct === null && this.paymentDate === null && this.identificatorBillet === '' && this.selectedItemFiltersInvoicePaid === null
    },
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  watch: {
    endDateFormated (val) {
      if (!val) {
        this.endDate = null
      }
    },
    paymentDateFormated (val) {
      if (!val) {
        this.paymentDate = null
      }
    },
    selectedItemFiltersInvoicePaid (val) {
      if (!val && val !== false) {
        this.selectedItemFiltersInvoicePaid = null
      }
    },
    selectedProduct (val) {
      if (!val) {
        this.selectedProduct = null
      }
    },
    pagination: {
      handler () {
        this.getAllInvoices()
      },
      deep: true
    }
  },
  mounted () {
    this.getAllClients()

    this.getAllProductPlans()

    this.getPlanTypes()

    this.clearFields()
  },
  beforeDestroy () {
    this.CLEAR_INVOICE_STORE()
  },
  methods: {
    ...mapActions([
      'actionGetAllInvoices',
      'actionGetAllClients',
      'actionSendInvoiceFile',
      'actionGetAllProductPlans',
      'actionGetValueInvoice',
      'actionGetCreditInfo',
      'actionGetPlanTypes'
    ]),
    ...mapMutations([
      'SET_SELECTED_INVOICE',
      'CLEAR_INVOICE_STORE'
    ]),
    clearClient () {
      this.loadPayments = false
    },
    planSubtitle (plan) {
      switch (plan) {
        case 'Light':
          return 'Limitado | Até 01 usuários free. 0h de reuniões/mês, suporte via Jira.'
        case 'Standard':
          return 'Limitado | Até 03 usuários free, 2h de reunião/mês, suporte via Jira'
        case 'Business':
          return 'Limitado | Até 05 usuários free, 4h de reunião/mês, suporte via Jira'
        case 'Enterprise':
          return 'Limitado | Até 10 usuários free, 8h de reunião/mês, suporte via Jira'
        case 'Custom':
          return 'Ilimitado | Usuários free ilimitados, reuniões ilimitadas, suporte via Jira'
        default:
          return ''
      }
    },
    getSelectedClientPlanType () {
      if (this.selectedClient) {
        const client = this.getterClients.find((item) => item.idClient === this.selectedClient)
        const planType = this.getterPlanType.find((item) => item.idPlanType === client.idPlanType)

        return planType
      }
      return null
    },
    getPlanTypes () {
      this.isLoading = true

      this.actionGetPlanTypes()
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao buscar as informações de planos, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoading = false
        })
    },
    balanceText () {
      return this.showCreditInfo ? 'Ocultar saldo' : 'Exibir saldo'
    },
    invoiceText () {
      return this.filterByStatus ? 'TODAS AS FATURAS PENDENTES' : 'TODAS AS FATURAS'
    },
    checkIfInvoicesAreSettled () {
      const invoices = this.getterAllInvoices.data

      if (invoices && invoices.length > 0) {
        const invoicesNotSettled = invoices.filter((item) => !item.settled)

        return invoicesNotSettled.length > 0
      }

      return false
    },
    getCreditInfo () {
      this.isLoading = true
      this.loadingCredit = true

      if (!this.selectedClient) {
        this.sendToast({
          text: 'Selecione um cliente para buscar as informações!',
          type: 'danger'
        })

        this.isLoading = false
        this.loadingCredit = false

        return
      }

      if (!this.selectedClient) {
        this.sendToast({
          text: 'Selecione um cliente para buscar as informações!',
          type: 'danger'
        })

        this.isLoading = false

        return
      }

      this.actionGetCreditInfo(this.selectedClient)
        .then(() => {
          this.loadPayments = true
          this.selectedClientPlanType = this.getSelectedClientPlanType()
          this.isLoading = false
          this.loadingCredit = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao buscar as informações do usuário, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoading = false
          this.loadingCredit = false
        })
    },
    getAllProductPlans () {
      this.isLoadingProductPlans = true

      this.actionGetAllProductPlans()
        .then(() => {
          this.isLoadingProductPlans = false
        })
        .catch(() => {
          this.isLoadingProductPlans = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os planos do cliente, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    managerPaymentModals (type, payment) {
      switch (type) {
        case 'identifier':
          this.managerUpdateBillet = true
          break
        case 'close-extract':
          this.managerCloseExtract = true
          break
        case 'remove-extract':
          this.managerConfirmDeleteInvoice = true
          break
        case 'download-file':
          this.managerDownloadFile = true
          break
        default:
          this.managerUpdateBillet = true
      }

      this.SET_SELECTED_INVOICE(payment)
    },
    validateDisabledButton (type, condition) {
      let result = false

      switch (type) {
        case 'close-extract':
          result = condition.settled
          break
        case 'identifier':
          result = condition.settled
          break
        case 'remove-extract':
          result = condition.settled
          break
        default:
          result = false
      }

      return result
    },
    getValueInvoice (item) {
      this.selectedInvoice = item

      this.isLoadingValueInvoice = true

      this.actionGetValueInvoice(item)
        .then(() => {
          this.isLoadingValueInvoice = false
        })
        .catch(() => {
          this.isLoadingValueInvoice = false
        })
    },
    validateDate (date) {
      if (!date) {
        return true
      }
      const isDateValid = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
      if (isDateValid !== 'Invalid date') {
        return true
      }
      return false
    },
    changeFilter () {
      this.filterByStatus = !this.filterByStatus

      this.getAllInvoices('filter')
    },
    getAllInvoices (isFiltered) {
      const formatDate = (date) => (date ? `${moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00` : '')

      if (!this.isDisabled) {
        this.showSection = true

        const params = {
          idClient: this.selectedClient || '',
          page: this.pagination.page,
          size: this.pagination.rowsPerPage,
          closingDay: formatDate(this.endDate),
          paymentDate: formatDate(this.paymentDate),
          idBillet: this.identificatorBillet.trim(),
          settled: false
        }

        if (!this.filterByStatus) {
          params.settled = this.selectedItemFiltersInvoicePaid
        }

        if (isFiltered !== 'filter') {
          this.getCreditInfo()
        }

        this.isLoading = true

        this.actionGetAllInvoices(params)
          .then(() => {
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Ocorreu um erro ao buscar os dados, tente novamente mais tarde!',
              type: 'danger'
            })
          })
      }
    },

    sendInvoiceFile () {
      const data = {
        base64: this.uploadedFile[0].base64,
        idUserLogged: this.getterAccount.idUser
      }

      this.isLoadingSendFile = true

      this.actionSendInvoiceFile(data)
        .then(() => {
          this.isLoadingSendFile = false

          this.sendToast({
            text: 'Arquivo enviado com sucesso',
            type: 'success'
          })

          setTimeout(() => {
            this.getAllInvoices()
          }, 100)
        })
        .catch(() => {
          this.isLoadingSendFile = false

          this.sendToast({
            text: 'Ocorreu um erro ao enviar o arquivo',
            type: 'danger'
          })
        })
    },
    getAllClients () {
      this.isLoadingAllClients = true

      this.actionGetAllClients()
        .then(() => {
          this.isLoadingAllClients = false
        })
        .catch(() => {
          this.isLoadingAllClients = false

          this.sendToast({
            text: 'Não foi possível buscar os clientes',
            type: 'danger'
          })
        })
    },

    linkToDownload (item) {
      return `${service.API_INVOICE}?id_invoice=${item.idInvoice}`
    },

    downloadInvoice (item) {
      this.isLoading = true

      const url = `${service.API_INVOICE_DOWNLOAD}?id_invoice=${item.idInvoice}`

      const oReq = new XMLHttpRequest()

      oReq.open('GET', url, true)
      oReq.responseType = 'arraybuffer'
      oReq.setRequestHeader('x-access-token', window.localStorage.getItem('access_token'))
      oReq.onload = function () {
        if (this.status < 299) {
          this.isLoading = false

          const finalFileName = `${item.idInvoice}.xlsx`
          const blob = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const downloadLink = document.createElement('a')
          let url = ''

          url = window.URL.createObjectURL(blob)

          downloadLink.href = url
          downloadLink.download = finalFileName
          downloadLink.click()
          window.URL.revokeObjectURL(url)

          this.sendToast({
            text: 'Download do arquivo realizado com sucesso!',
            type: 'success'
          })
        } else {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao fazer o download do arquivo, tente novamente mais tarde!',
            type: 'danger'
          })
        }

        this.isLoading = false
      }

      oReq.send()
      this.isLoading = false
    },

    clearFields () {
      this.endDate = this.paymentDate = this.paymentDateFormated = this.endDateFormated = this.selectedItemFiltersInvoicePaid = null
      this.isLoading = this.isLoadingSendFile = false
      this.uploadedFile = []
      this.selectedClient = this.identificatorBillet = ''

      this.CLEAR_INVOICE_STORE()
    }
  }
}
